import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
    selector: "app-multiple-tags",
    templateUrl: "./multiple-tags.component.html",
    styleUrls: ["./multiple-tags.component.scss"],
})
export class MultipleTagsComponent implements OnChanges {
    @Input() public tags: string = "";

    public tagsShown: string[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["tags"]) {
            if (!this.tags) {
                this.tagsShown = [];
            } else {
                const newTags: string = changes["tags"].currentValue;
                this.tagsShown = this.computeTagsShown(newTags);
            }
        }
    }

    public computeTagsShown(tags: string): string[] {
        const splittedTags = tags.split(",").map((tag) => tag.trim());
        return splittedTags.length === 1 ? splittedTags : [splittedTags[0], splittedTags.slice(1).join(",")];
    }
}
